import { lazy, Suspense } from "react";
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import { IAddress } from "common/types";
import { toPhone } from "common/utils/formatting";
import Icon from "common/components/Icon";
import { Optional } from "common/utils/types";

import { MapProps } from "client/common/types";

import Address from "./Address";
import Loading from "../loading/Loading";

import styles from "../../styles/MapBox.module.less";

const LazyMap = lazy(() => import("./Map"));

type MapBoxProps = MapProps & {
  icon?: IconProp;
  address: IAddress;
  contactInfo?: {
    phone_number: Optional<number>;
    email: Optional<string>;
  };
  className?: string;
};

const MapBox = ({
  icon = faLocationDot,
  address,
  contactInfo,
  className = "",
  ...mapProps
}: MapBoxProps) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <Suspense fallback={<Loading />}>
        <LazyMap {...mapProps} className={styles.map} />
      </Suspense>
      <div className={styles.addressRow}>
        <div className={styles.addressContent}>
          <Icon icon={icon} className={styles.icon} />
          <Address
            address={address}
            includeName={false}
            styles={{ address: styles.address, street: styles.street }}
          />
        </div>
        {contactInfo && (
          <div className={styles.info}>
            {contactInfo.phone_number && <span>T: {toPhone(contactInfo.phone_number)}</span>}
            {contactInfo.email && <span>{contactInfo.email}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default MapBox;
